import { firebase } from "@data/firebase/config";
import { clientAddressStatus } from "@domain/models/Client";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { fireabseAdapter } from "./firebaseAdapter";
import { MapClientStore } from "@domain/stores/MapClientStore";
import DatabaseMapClientRepository from "@domain/repositories/DatabaseMapClientRepository";
import { MapClient } from "@domain/models/MapClient";

export class FirebaseMapClientRepository implements DatabaseMapClientRepository {
  COLLECTION = "mapClients";

  constructor(private readonly mapClientStore: MapClientStore) {}

  watchMapClientsAdmin() {
    const consulta = query(collection(firebase.db, this.COLLECTION));
    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<MapClient>(querySnapshot);

        this.mapClientStore.updateMapClients(mappedDocs);
      },
      (error) => console.log("watchMapClientsAdmin error", error)
    );
  }

  watchMapClientsManager(mapsIds: string[]) {
    const consulta = query(
      collection(firebase.db, this.COLLECTION),
      where("addressStatus", "==", clientAddressStatus.FOUND),
      where("mapId", "in", mapsIds)
    );
    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<MapClient>(querySnapshot);

        this.mapClientStore.updateMapClients(mappedDocs);
      },
      (error) => console.log("watchMapClientsManager error", error)
    );
  }

  watchMapClientsOperator(userId: string, mapsIds: string[]) {
    const consulta = query(
      collection(firebase.db, this.COLLECTION),
      where("addressStatus", "==", clientAddressStatus.FOUND),
      where("mapId", "in", mapsIds),
      where("isSelected", "==", false)
    );
    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<MapClient>(querySnapshot);

        const filtered: MapClient[] = [];

        for (const client of mappedDocs) {
          if (client.hasReturn) {
            if (client.operatorId === "" || client.operatorId === userId) {
              filtered.push(client);
            }
          } else {
            filtered.push(client);
          }
        }

        this.mapClientStore.updateMapClients(filtered);
      },
      (error) => console.log("watchMapClientsOperator error", error)
    );
  }
}
